import React, { useState } from "react";
import styless from './style.module.css';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Universalpageheader from "../Headers/universalpageheader";
import Searchbar from "../Components/searchbar";
import { CreditCard, Grading, LocalShipping, ReplayCircleFilled } from "@mui/icons-material";




const Faqs = () => {
    const navigate = useNavigate();
    const subProducts = useSelector((state) => state.subProducts.data);
    const [showsearchbar, setshowsearchbar] = useState(false);


    const webSettings = useSelector((state) => state.webSettings.data);

    const fullName = webSettings.FULL_NAME;
    const firstname = fullName?.split(' ')[0];

    document.title = fullName + 'Frequently asked Questions'

    const [moduleactive, setmoduleactive] = useState('payments');





    return (
        <div>
            {showsearchbar && <Searchbar dismissmodals={() => setshowsearchbar(false)} products={subProducts?.flatMap((obj) => obj.items)} />}
            <Universalpageheader onshowsearch={() => setshowsearchbar(true)} pagename={"FAQ'S"} withbackicon={true} />
            <div>
                <div className="wrapfaqsbuttons">
                    <div className={moduleactive === 'payments' ? "faqsbuttonactive" : "faqsbutton"} onClick={() => setmoduleactive('payments')}>  <CreditCard />&nbsp;&nbsp;  Payments </div>
                    <div className={moduleactive === 'ordering' ? "faqsbuttonactive" : "faqsbutton"} onClick={() => setmoduleactive('ordering')}>  <Grading />&nbsp;&nbsp;  Ordering </div>
                    <div style={{ minWidth: "210px" }} className={moduleactive === 'shipping' ? "faqsbuttonactive" : "faqsbutton"} onClick={() => setmoduleactive('shipping')}>  <LocalShipping />&nbsp;&nbsp;  Shipping & Delivery </div>
                    <div className={moduleactive === 'returns' ? "faqsbuttonactive" : "faqsbutton"} onClick={() => setmoduleactive('returns')}>  <ReplayCircleFilled />&nbsp;&nbsp; Returns </div>
                </div>

                <div style={{
                    width: "95%",
                    margin: "auto"
                }}>
                    {moduleactive === "payments" && <Payments sitename={firstname} webSettings={webSettings} />}
                    {moduleactive === "ordering" && <Ordering sitename={firstname} webSettings={webSettings} />}
                    {moduleactive === "shipping" && <Delivery sitename={firstname} webSettings={webSettings} />}
                    {moduleactive === "returns" && <Returns sitename={firstname} webSettings={webSettings} />}
                </div>
            </div>
        </div >
    )
}

export default Faqs;




const Payments = ({ sitename, webSettings }) => {

    const [showfaq, setshowfaq] = useState(false);
    const [number, setnumber] = useState(1);

    function toggleFAQ(faqNumber) {
        var faq = document.getElementById('faq' + faqNumber);
        if (faq.style.display === 'block') {
            faq.style.display = 'none';
        } else {
            faq.style.display = 'block';
        }
    }

    return (
        <div>
            <div className="faq-container">
                <div className="faq-question" onClick={() => toggleFAQ(1)}>
                    <span>What payment methods are supported on {sitename}?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq1">
                    We accept a variety of payment methods including:

                    <li>Pay on Delivery allows for payment via mobile money(Mpesa,Airtel Money) upon delivery instead of cash.</li>
                    <li>{sitename} accepts payment through Mpesa, Airtel Money, Mastercard, or Visa cards.</li>
                    <li>Vouchers: Pay using a voucher code when placing your order.</li>
                </div>

                <div className="faq-question" onClick={() => toggleFAQ(2)}>
                    <span>How secure is my payment information on {sitename}?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq2">
                    <p>
                        {sitename} prioritizes customer payment security with encryption,
                        and secure servers. Regular monitoring and auditing are also
                        performed to maintain a secure environment for transactions.
                    </p>
                </div>

                <div className="faq-question" onClick={() => toggleFAQ(3)}>
                    <span>What do i do if my payment is declined?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq3">
                    If your payment is declined, you can check the following to resolve the issue:
                    <br />
                    <b>For M-Pesa;</b>
                    <li>Check if you have sufficient funds .</li>

                    <li>Ensure your phone number is not linked to another account on {sitename}.</li>

                    <li>Ensure you have entered the correct pin</li>
                    <br /><br />
                    <b> For Card;</b>
                    <li>Check the spelling and billing information you entered for accuracy.</li>

                    <li>Ensure that your credit card has sufficient funds or that your bank account has enough balance.</li>

                    <li>Check if there are any restrictions on your card, such as a daily spending limit.</li>

                    <li>Make sure your card has not expired.</li>


                    If you've checked the above and your payment is still declined, you can contact {sitename} customer service for assistance. They can be reached through the Live Chat or by calling {sitename} customer service through  {webSettings.TELEPHONES_LINK}  for assistance.

                    <br /><br />
                    <b> Note: It is recommended to keep the details of the error message that appears during the declined transaction to provide to {sitename} customer service for a faster resolution.</b>
                </div>

                <div className="faq-question" onClick={() => toggleFAQ(4)}>
                    <span>Can I pay on delivery for my orders?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq4">
                    You can pay for your {sitename} orders upon delivery using mpesa.
                </div>

                <div className="faq-question" onClick={() => toggleFAQ(5)}>
                    <span>What do i do if i have been charged twice for the same order?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq5">
                    If you have been charged twice for the same order, you can contact {sitename} customer service for assistance in resolving the issue. They can be reached through the Live Chat or by calling {sitename} customer service through  {webSettings.TELEPHONES_LINK} for assistance.
                    <br /><br />
                    Please provide the following information to {sitename} customer service when reporting a double charge:

                    <li>Your name and email address used to place the order.</li>

                    <li>Order number and date of purchase.</li>

                    <li>Details of the double charge (amount, date, and transaction number).</li>
                    <br /><br />
                    {sitename} customer service will assist you in resolving the issue and arranging for a refund if applicable.
                </div>
                <div className="faq-question" onClick={() => toggleFAQ(6)}>
                    <span>How long does it take for my payment to be processed?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq6">
                    Most payments on {sitename} are processed immediately when completed.
                    However, specific processing times may vary depending on the
                    payment method. To ensure that your payment is processed quickly,
                    we recommend that you double-check all the information before
                    completing checkout. If you are experiencing an issue with your
                    payment, please contact {sitename}'s customer service team for assistance.
                </div>
                <div className="faq-question" onClick={() => toggleFAQ(7)}>
                    <span>Can i cancel my order and get a refund after payment has been made?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq7">
                    If the order hasn't been shipped yet, you can cancel and get a refund.
                </div>
            </div>
        </div>
    )
}



const Ordering = ({ sitename, webSettings }) => {

    function toggleFAQ(faqNumber) {
        var faq = document.getElementById('faq' + faqNumber);
        if (faq.style.display === 'block') {
            faq.style.display = 'none';
        } else {
            faq.style.display = 'block';
        }
    }

    return (
        <div>
            <div className="faq-container">
                <div className="faq-question" onClick={() => toggleFAQ(1)}>
                    <span>What types of products does {sitename} offer?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq1">
                    Discover a wide range of high-quality products at {webSettings.FULL_NAME}
                </div>

                <div className="faq-question" onClick={() => toggleFAQ(2)}>
                    <span>How do i search for a specific product?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq2">
                    You can search for a specific product on {sitename} by using the
                    search bar located at the top of the website. Enter the name
                    of the product you are looking for into the bar, and then click
                    the 'search' button. You will be presented with a list of results
                    which match your criteria. You can then browse through the list
                    to find the exact product you are looking for. Additionally, you
                    can narrow down your search results by selecting filters such as
                    price range, brand and more.
                </div>

                <div className="faq-question" onClick={() => toggleFAQ(3)}>
                    <span>How can i view product details and specifications?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq3">
                    Product details and specifications for items sold on {sitename}
                    can be easily accessed by clicking on the product's listing.
                    Once you have selected the desired item, scroll down to the
                    bottom of the page where you will find a detailed description
                    of the product's features and specifications. The product's details
                    also include a list of images for the product, ratings and reviews
                    from other customers, and a list of related items.
                </div>

                <div className="faq-question" onClick={() => toggleFAQ(4)}>
                    <span>How do i know of a product is in stock?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq4">
                    You can simply visit the product page and look for the
                    "In Stock" label. If the product is currently in stock,
                    you will see the "In Stock" label. If the product is not
                    in stock, the label will not be present. If you need to
                    check the availability of a specific item, you can also
                    use the search bar on the {sitename} website. Enter the product
                    name or SKU number to see if it is in stock. If the product
                    is available, you will also see the "In Stock" label on the product page.
                </div>

                <div className="faq-question" onClick={() => toggleFAQ(5)}>
                    <span>How can i write feedback or write review of a product?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq5">
                    Just follow these steps:<br />
                    <b>Step 1:</b> Go to your account in the top right corner of the main page.<br /><br />
                    <b>Step 2:</b> Choose “PENDING REVIEWS”.<br /><br />
                    <b>Step 3:</b> Find the item you purchased and select “Write a Review”.<br /><br />
                    <b>Step 4:</b> Provide your honest feedback regarding the product and submit it<br /><br /><br />
                    Your feedback will be visible to other customers and can help them make informed decisions when purchasing from {sitename}.
                </div>

            </div>
        </div>
    )
}



const Delivery = ({ sitename, webSettings }) => {

    function toggleFAQ(faqNumber) {
        var faq = document.getElementById('faq' + faqNumber);
        if (faq.style.display === 'block') {
            faq.style.display = 'none';
        } else {
            faq.style.display = 'block';
        }
    }

    return (
        <div>
            <div className="faq-container">
                <div className="faq-question" onClick={() => toggleFAQ(1)}>
                    <span>How can i track my delivery?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq1">
                    To track your delivery on {sitename}, you can follow these steps:
                    <br /><br />
                    <b>Step 1:</b> Log in to your account.<br /><br />
                    <b>Step 2:</b> Click on the "My Account" button and select "ORDERS" from the dropdown menu.<br /><br />
                    <b>Step 3:</b> Locate the order for which you want to track the delivery and click on the "View Details" button.<br /><br />
                    <b>Step 4:</b> On the order details page, look for the delivery status under the "Order Information" section. If the delivery status is "Shipped," you can click on the "Track Package" button.<br /><br />
                    <b>Step 5:</b> This will take you to the delivery tracking page, where you can view the current status of your delivery and any available tracking information.<br /><br />
                    <b>Step 6:</b> If you have any concerns about the delivery status, you can contact {sitename}'s customer service team by clicking on the "Help" button at the top right of the page and selecting "Live Chat" from the dropdown menu or by calling {sitename} customer service through  {webSettings.TELEPHONES_LINK}  for assistance.<br /><br />
                </div>

                <div className="faq-question" onClick={() => toggleFAQ(2)}>
                    <span>What if i'm not available to receive my delivery?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq2">
                    <b>If you are not available to receive your delivery, you have the following options:</b><br />
                    <li>You can arrange for someone else to receive it on your behalf by providing their name and contact information to the delivery agent. It is important to ensure that this person is available at the same address that was provided when placing your order.</li>
                    <li>Contact the delivery agent to reschedule the delivery for a more convenient time.</li>
                    <li>If you are unable to arrange for an alternative delivery, you can contact {sitename}'s customer service team to request a rescheduling of the delivery. You can reach them by clicking on the "Help" button at the top right of the page and selecting "Live Chat" from the dropdown menu or by calling {sitename} customer service through  0711011011  for assistance.</li>
                    <br /><br />
                    <b>Note:</b> It is not possible to change the delivery address once an order is placed. {sitename} will make a total of <b>2 attempts</b> to deliver the package before canceling your order. You will be notified before they make the second attempt, so it's important to remain available to avoid order cancelation
                </div>

                <div className="faq-question" onClick={() => toggleFAQ(3)}>
                    <span>Can i change my delivery address after placing an order?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq3">
                    It is important to carefully review and confirm the accuracy of
                    your delivery information, such as your address and phone number,
                    before placing an order on {sitename}. Once the order has been placed,
                    <b>it is not possible to make changes to the delivery information.</b>
                    To make sure that your order is delivered properly, please double-check your delivery information on the checkout page.
                </div>

                <div className="faq-question" onClick={() => toggleFAQ(4)}>
                    <span>What is the delivery fee?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq4">
                    The delivery fee is the cost incurred by {sitename} and its logistics
                    partners for delivering your order to the selected address. The
                    delivery fee amount can vary based on factors such as your geographic
                    location, the delivery method chosen, the shipment method, and the
                    size or category of the product ordered. You can review the delivery
                    fee before placing your order on the product page and during the checkout process.
                </div>

                <div className="faq-question" onClick={() => toggleFAQ(5)}>
                    <span>What do i do if my delivery has not arrived within the estimated timeframe?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq5">
                    If your delivery has not arrived within the estimated time frame, you can follow these steps:
                    <br /><br />
                    <li>Check the order information page in your {sitename} account for any updates on the delivery status.</li>
                    <li>Monitor communication sent through push notifications, emails, and the APP INBOX for any updates on the delivery status of your order.</li>
                    <li>Contact the delivery agent by using the contact information provided in the email sent to you when your package is “out for delivery”.</li>
                    <li>If you are unable to reach the delivery agent, or if the delivery status has not been updated, you can reach out to {sitename}'s customer service team for assistance. You can reach them by clicking on the "Help" button at the top right of the page and selecting "Live Chat" from the dropdown menu or by calling {sitename} customer service through  {webSettings.TELEPHONES_LINK}  for assistance.</li>
                    <br /><br />
                    <b>Note:</b> We will work with you to ensure that your delivery arrives as soon as possible, so it is important to reach out to us if you have any concerns or questions regarding the delivery of your order.
                </div>

                <div className="faq-question" onClick={() => toggleFAQ(6)}>
                    <span>Who do i contact if there's a problem with my delivery?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq6">
                    To contact {sitename} regarding a problem with your delivery, you have the following options:

                    <li>Live Chat support on the website</li>

                    <li>Calling the phone support line at {webSettings.TELEPHONES_LINK} from Monday to Friday, between 8am and 8pm; and on weekends and holidays from 8am to 7pm</li>
                </div>

            </div>
        </div>
    )
}



const Returns = ({ sitename, webSettings }) => {

    function toggleFAQ(faqNumber) {
        var faq = document.getElementById('faq' + faqNumber);
        if (faq.style.display === 'block') {
            faq.style.display = 'none';
        } else {
            faq.style.display = 'block';
        }
    }

    return (
        <div>
            <div className="faq-container">
                <div className="faq-question" onClick={() => toggleFAQ(1)}>
                    <span>What is {sitename}'s return policy?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq1">
                    {sitename} accepts returns for most items within 10 days after delivery. To be eligible for a return, the product must be in its original condition and packaging, with all accessories and tags still intact.
                    <br /><br />
                    It's important to note that some categories, such as those related to personal hygiene, may not be eligible for return.
                </div>

                <div className="faq-question" onClick={() => toggleFAQ(2)}>
                    <span>How do i initiate a return on {sitename}?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq2">
                    <b>Step 1:</b> Log in to your {sitename} account and go to "ORDERS".<br /><br />
                    <b>Step 2:</b> Click on the order of the item(s) you want to return.<br /><br />
                    <b>Step 3:</b> Select the item(s) you want to return and provide a reason for the return. Give more details to help us understand the issue.<br /><br />
                    <b>Step 4:</b> Choose your preferred refund method.<br /><br />
                    <b>Step 5:</b> Select whether you would like to personally drop off the returned item or have {sitename} pick it up.<br /><br />
                    <b>Step 6:</b> Review your information and submit your return request.<br /><br />
                </div>

                <div className="faq-question" onClick={() => toggleFAQ(3)}>
                    <span>What if i received a damaged or defective item?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq3">
                    If you receive a damaged or defective item,
                    you can initiate a return by going to <b>“ORDERS''</b>
                    in your {sitename} account and create a return immediately
                    or within 24 hours. {sitename} will process a refund for the
                    item once returned and claim confirmed
                </div>

                <div className="faq-question" onClick={() => toggleFAQ(4)}>
                    <span>How long does it take to process a return on {sitename}?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq4">
                    It typically takes 7-10 business days to process a return on {sitename}.
                </div>

                <div className="faq-question" onClick={() => toggleFAQ(5)}>
                    <span>How will i receive my refund after returning items on {sitename}?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq5">
                    Refunds will be credited to your original payment method,
                    depending on the payment method used at the time of purchase.
                </div>

                <div className="faq-question" onClick={() => toggleFAQ(6)}>
                    <span>Why was my return request declined and the item sent back to me?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq6">
                    Your return request was declined by the {sitename} Quality Check Team because
                    the eligibility conditions for return were not met, or the return claim
                    could not be confirmed after thorough testing. This may have occurred
                    if you returned the item without its original packaging, or if an unsealed
                    product (such as a phone or laptop) was returned but found to be functional.
                    If you choose not to accept the returned item, it will be held in {sitename}'s warehouse
                    for 30 days. After this time, if the item is not claimed, it will be forfeited and become
                    the property of {sitename}, and no refund will be issued.
                </div>
                <div className="faq-question" onClick={() => toggleFAQ(7)}>
                    <span>I received an error that my item cannot be returned, why is that?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq7">
                    If you receive an error message that your item cannot be returned,
                    it's likely due to {sitename}'s policy for customer safety and protection.
                    Certain items cannot be returned, except in the case of receiving a wrong,
                    defective, counterfeit, damaged, incomplete, or expired item.
                </div>
                <div className="faq-question" onClick={() => toggleFAQ(8)}>
                    <span>Does my product have a warranty?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq8">
                    The warranty information for a product can be found on its listing page on {sitename}.
                </div>
                <div className="faq-question" onClick={() => toggleFAQ(9)}>
                    <span>Is is it possible to request for an exchange instead of a refund or return?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq9">
                    Currently, {sitename} does not offer an exchange option for items.
                    However, if you receive a wrong item you can still return the
                    item and received a full refund.
                </div>
                <div className="faq-question" onClick={() => toggleFAQ(10)}>
                    <span>I received a refund confirmation ,but the amount received is incorrect.what should i do?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq10">
                    We apologize for the inconvenience. All refunds are processed to reflect the
                    original amount paid for the order. If you believe the amount you received is
                    incorrect, please reach out to us for further investigation and resolution
                    via Live Chat or by calling {sitename} customer service through  {webSettings.TELEPHONES_LINK}  for assistance.
                </div>
                <div className="faq-question" onClick={() => toggleFAQ(11)}>
                    <span>Do i need to pay for delivery fee when returning an item?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq11">
                    You do not need to pay for any delivery fees when returning a product to {sitename}.
                </div>
                <div className="faq-question" onClick={() => toggleFAQ(12)}>
                    <span>I submitted my return request, but have changed my mind and no longer wish to return the item. What should I do?</span>
                    <span>+</span>
                </div>
                <div className="faq-answer" id="faq12">
                    In order to cancel your return request, please contact us via
                    Live chat or our customer service line {webSettings.TELEPHONES_LINK}.
                    If you have already been contacted for pickup, you may request the delivery associate to cancel it for you on your behalf
                </div>
                <div className='returnname'>Return process</div>
                <img src={require("./../../assets/faqs/return1.png")} className='returnimage' />
                <div className='returnname'> Return & Refund Process:</div>
                <img src={require("./../../assets/faqs/return2.png")} className='returnimage' />
                <div className='returnname'>Exchange Process:</div>
                <img src={require("./../../assets/faqs/return3.png")} className='returnimage' />
                <div className='returnname'>Refund Only Process:</div>
                <img src={require("./../../assets/faqs/return4.png")} className='returnimage' />
            </div>
        </div>
    )
}
